export const ACCESS_TOKEN_KEY = 'accessToken'
export const USER_INFO_KEY = 'userInfo'

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && Boolean(window.sessionStorage)
}

export function getAccessToken(): string {
  if (!canUseStorage()) {
    return ''
  }

  return window.sessionStorage.getItem(ACCESS_TOKEN_KEY) || ''
}

export function setAccessToken(token: string): void {
  if (!canUseStorage()) {
    return
  }

  window.sessionStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function clearAccessToken(): void {
  if (!canUseStorage()) {
    return
  }

  window.sessionStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function setUserInfo(userInfo?: string | null): void {
  if (!canUseStorage()) {
    return
  }

  if (!userInfo || userInfo === 'undefined' || userInfo === 'null') {
    window.sessionStorage.removeItem(USER_INFO_KEY)
    return
  }

  window.sessionStorage.setItem(USER_INFO_KEY, userInfo)
}

export function clearUserInfo(): void {
  if (!canUseStorage()) {
    return
  }

  window.sessionStorage.removeItem(USER_INFO_KEY)
}
